// Importing Common API rules
import { httpClient } from '@/modules/shared/services';
// Users API Links
import { apiConstants } from '../config';


export const authResource = {
	getCsrf,
	login,
	getUser,
	logout,
}

async function getCsrf()
{
	return await httpClient.get(apiConstants.csrf)
					.then(res => res);
}

async function login(username, password)
{
	var data = {
		username: username,
		password: password
	};

	return await httpClient.post(apiConstants.login, data)
					.then(res => res);
}

async function getUser()
{
	return await httpClient.get(apiConstants.getUserDetails)
					.then(res => res.data);
}

async function logout()
{
	return await httpClient.get(apiConstants.logout)
					.then(res => res);
}
